import { render, staticRenderFns } from "./IndagineEpidemiologicaSalmonellosiNonTifoideaViewComponent.vue?vue&type=template&id=69adf30b"
import script from "./IndagineEpidemiologicaSalmonellosiNonTifoideaViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaSalmonellosiNonTifoideaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports